import { Target, Lightbulb, Bot, Zap } from "lucide-react";
import { Reveal } from "./Reveal";
import { DIFFERENTIATORS, WHY_US } from "../data/content";

const ICONS = { target: Target, lightbulb: Lightbulb, bot: Bot, zap: Zap };

export const About = () => (
  <section className="section" id="about" data-testid="about-section">
    <div className="wrap">
      <Reveal><h2 className="eyebrow about-eyebrow" data-testid="about-heading-eyebrow"><span className="sq" /> About Us</h2></Reveal>
      <Reveal delay={60}>
        <p className="about-lead" data-testid="about-lead">
          We partner with startups, growing businesses, enterprises, and government organizations to create
          brands that not only look exceptional but also perform in the real world. Our expertise combines
          branding, marketing, design, storytelling, AI-powered workflows, and performance thinking to deliver
          measurable business impact.
        </p>
      </Reveal>
      <Reveal delay={120}>
        <p className="about-tag" data-testid="about-tagline">
          From building a brand from scratch to launching nationwide campaigns.
        </p>
      </Reveal>

      <Reveal delay={160}>
        <h3 className="sub-head" data-testid="different-heading">What makes us different</h3>
        <div className="diff-grid">
          {DIFFERENTIATORS.map((d) => {
            const Icon = ICONS[d.icon];
            return (
              <div className="diff-card" key={d.title} data-testid={`diff-card-${d.icon}`}>
                <div className="ico"><Icon size={22} strokeWidth={2} /></div>
                <h4>{d.title}</h4>
                <p>{d.text}</p>
              </div>
            );
          })}
        </div>
      </Reveal>

      <Reveal delay={200}>
        <h3 className="sub-head" style={{ marginTop: 72 }} data-testid="why-choose-heading">Why choose us</h3>
        <div className="why-grid">
          {WHY_US.map((w, i) => (
            <div className="why-item" key={w.title} data-testid={`why-item-${i + 1}`}>
              <div className="dot">{i + 1}</div>
              <div>
                <h4>{w.title}</h4>
                <p>{w.text}</p>
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
